import React from 'react';
import { Navigate } from 'react-router-dom';
import { useAuth, isAdmin } from '@/lib/auth';

export default function ProtectedRoute({ children, requireAdmin = false }) {
    const { user, loading } = useAuth();
    if (loading) {
        return (
            <div className="min-h-screen flex items-center justify-center" data-testid="auth-loading">
                <div className="text-slate-500">Loading…</div>
            </div>
        );
    }
    if (!user) return <Navigate to="/login" replace />;
    if (requireAdmin && !isAdmin(user)) return <Navigate to="/learn" replace />;
    return children;
}
